import { Component, OnInit, OnDestroy, HostListener, AfterViewInit } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import 'hammerjs';
import * as $ from 'jquery';
import * as slick from 'ngx-slick';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})

export class AboutComponent implements OnInit, OnDestroy, AfterViewInit {

  private fragment: string;

  constructor(public angulartics2: Angulartics2,
              private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
    });
    if (this.angulartics2) {
      this.angulartics2.eventTrack.next({
        action: 'page-view-about'
      });
      console.log(this.angulartics2);
    }
  }

  ngAfterViewInit(): void {
    try {
      if (this.fragment === 'title') {
        $('html,body').scrollTop(0);
      } else {
        $('html, body').animate({scrollTop: $('#' + this.fragment).offset().top}, {duration: 'medium'});
      }
    } catch (e) {
      // console.log(e);
    }
    if (window.innerWidth >= 1195) {
      $('#about-link').addClass('grey-text');
      $('#brands-link').addClass('grey-text');
      $('#team-link').addClass('grey-text');
      $('#investors-link').addClass('grey-text');
      $('#contact-link').addClass('grey-text');
    }
  }

  gotoBrands() {
    $('html, body').scrollTop(0);
    $('#under-bar').css({'opacity': 1});
    $('#under-bar').animate({'margin-left': '138px'});
    if (window.innerWidth <= 1194) {
      const mobileAbout = document.getElementById('mobile-about');
      mobileAbout.classList.remove('opac');
      const mobileBrands = document.getElementById('mobile-brands');
      mobileBrands.classList.add('opac');
      const mobileTeam = document.getElementById('mobile-team');
      mobileTeam.classList.remove('opac');
      const mobileInvestors = document.getElementById('mobile-investors');
      mobileInvestors.classList.remove('opac');
      const mobileContact = document.getElementById('mobile-contact');
      mobileContact.classList.remove('opac');
    }
  }

  ngOnDestroy() {

  }

}
